/*
  PMB2G1 cart auto-add — Peach Mango Buy 2 Get 1 Free.
  When the cart holds exactly TRIGGER_QTY one-time units of VARIANT, bumps the
  line to TARGET_QTY so the automatic BXGY discount zeroes the extra unit.
  Runs sitewide (PDP adds, collection quick-adds, drawer quantity steppers).
  A session flag stops it re-bumping after a shopper deliberately steps back
  down, so quantity controls stay usable.
  Kill: remove this script tag from layout/theme.liquid (or deactivate the
  PMB2G1 automatic discount — the two ship and die together).
*/
(function () {
  var VARIANT = 39329277902966;
  var TRIGGER_QTY = 2;
  var TARGET_QTY = 3;
  var FLAG = 'pmb2g1-autoadded';
  var checking = false;

  function otpTotal(cart) {
    // Total one-time units across lines: the BXGY discount SPLITS the variant
    // into separate paid and free lines, so a single-line read undercounts.
    return (cart.items || []).reduce(function (sum, i) {
      return sum + ((i.variant_id === VARIANT && !i.selling_plan_allocation) ? i.quantity : 0);
    }, 0);
  }

  function drawerSections() {
    var cart = document.querySelector('cart-drawer');
    return (cart && typeof cart.getSectionsToRender === 'function')
      ? cart.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';
  }

  function maybeBump() {
    if (checking) return;
    checking = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = otpTotal(cart);
        if (total === 0) { sessionStorage.removeItem(FLAG); return; }
        if (total !== TRIGGER_QTY) return;
        if (sessionStorage.getItem(FLAG)) return; // shopper stepped back down on purpose
        sessionStorage.setItem(FLAG, '1');
        // add.js is unambiguous when the discount has split the variant into
        // multiple lines (update.js keyed by variant id only hits one line).
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{ id: VARIANT, quantity: TARGET_QTY - TRIGGER_QTY }],
            sections: drawerSections(),
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var cartEl = document.querySelector('cart-drawer');
            if (cartEl && typeof cartEl.renderContents === 'function') {
              var isClosedCart = !document.body.classList.contains('page-overlay-cart-on');
              cartEl.renderContents(data, isClosedCart);
            }
          });
      })
      .catch(function () {})
      .finally(function () { checking = false; });
  }

  // Watch every cart mutation the storefront makes.
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update)(\.js)?/.test(url)) {
      p.then(function () { setTimeout(maybeBump, 150); }, function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update)(\.js)?/.test(url)) {
      this.addEventListener('loadend', function () { setTimeout(maybeBump, 150); });
    }
    return origOpen.apply(this, arguments);
  };

  // Native (no-JS-path) form submits land on a fresh page: check once per load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeBump);
  } else {
    maybeBump();
  }
})();
